import React, { useState } from 'react';
import { Tab, Tabs, Button, Spinner } from 'react-bootstrap';


const TabView = ({ onSubmit, onCancel, tabsInfo, onTabChange, isValidated, isSubmitDisable, submitInProgress = false }) => {
    const [key, setKey] = useState('member-info');
    const tabChanged = (k) => {
        if (isValidated) {
            setKey(k);
        }
        onTabChange(k);
    }

    return (
        <div className="px-xl-2 py-xl-2">
            <div className={`text-end mb-4`}>
                <Button
                    variant="outline-primary"
                    type="button"
                    className="me-2"
                    disabled={submitInProgress}
                    onClick={onCancel}>
                    Cancel
                </Button>
                <Button
                    variant="primary"
                    type="button"
                    className="me-2 d-inline-flex align-items-center"
                    disabled={isSubmitDisable || submitInProgress}
                    onClick={onSubmit}>
                    {submitInProgress ? (
                        <>
                            <Spinner animation="border" size="sm" className="me-2" role="status" aria-hidden />
                            Saving…
                        </>
                    ) : (
                        'Save'
                    )}
                </Button>
            </div>
            <Tabs
                activeKey={key}
                onSelect={(k) => tabChanged(k)}
                variant="underline"
                className="tabs mb-3">
                {tabsInfo.map((tab) => (
                    <Tab
                        key={tab.eventKey}
                        eventKey={tab.eventKey}
                        title={tab.title}>
                        {tab.child}
                    </Tab>
                ))}
            </Tabs>
        </div>
    );
};

export default TabView;
